import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'

import { BrowserRouter as Router, Route ,Switch} from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import { setCurrentUser, logoutUser } from './actions/authActions';

import { Provider } from 'react-redux';
import store from './store';

import Cookies from 'js-cookie'
import {setClientToken} from './actions/vhukit'

import dashboard from './components/dashboard'
import NotFound from './components/not-found/NotFound';
import Login from './components/auth/Login'
import Landing from './components/layout/Landing'

// Page
import listUsers from './components/pages/listUsers'
import listContentsApprove from './components/pages/listContentsApprove'
import listContents from './components/pages/listContents'
import Notification from './components/pages/Notification'
import Callback from './components/auth/callback'
import newContent from './components/pages/newContent'
import RollCall from './components/pages/RollCall'
import newRollCall from './components/pages/newRollCall'
import viewRollCall from './components/pages/viewRollCall'

// Template
import Header from './components/layout/Header'
import Sidebar from './components/layout/Sidebar'
import Footer from './components/layout/Footer'

import './App.css';

// Check for token
if (Cookies.get('act')) {
  setClientToken(Cookies.get('act'))
  const decoded = jwt_decode(Cookies.get('act'));
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    store.dispatch(logoutUser());
    //window.location.href = '/login';
  }
}


const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route {...rest} render={props => (
    <Layout>
      <Component {...props} />
    </Layout>
  )} />
)

const LandingLayout = props => (
  <React.Fragment>
    <Header/>
    <Sidebar/>
    <div className="page-container">
      {props.children}
      <Footer />
    </div>
  </React.Fragment >
)

const UserLayout = props => (
  <React.Fragment>
    {props.children}
  </React.Fragment>
)


class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <div className="App">
            <Switch>
              <AppRoute exact path="/" layout={UserLayout} component={Landing}/>
              <AppRoute exact path="/login" layout={UserLayout} component={Login} />
              <AppRoute exact path="/not-found" layout={UserLayout} component={NotFound} />
              
            </Switch>
            <Switch>
              <AppRoute path="/dashboard" layout={LandingLayout} component={dashboard}/>
              <AppRoute exact path="/users" layout={LandingLayout} component={listUsers} />
              <AppRoute exact path="/contents/approve" layout={LandingLayout} component={listContentsApprove}/>
              <AppRoute exact path="/contents/new" layout={LandingLayout} component={newContent}/>
              <AppRoute exact path="/contents" layout={LandingLayout} component={listContents}/>
              <AppRoute exact path='/notification' layout={LandingLayout} component={Notification}/>
              <AppRoute exact path='/auth/callback' layout={UserLayout} component={Callback}/>
              <AppRoute exact path='/diemdanh' layout={LandingLayout} component={RollCall}/>
              <AppRoute exact path='/diemdanh/new' layout={LandingLayout} component={newRollCall}/>
              <AppRoute exact path='/diemdanh/:id' layout={UserLayout} component={viewRollCall}/>
            </Switch>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js